import React from 'react'

function Error({ errorData, onShowDemoPost }) { 
    return (
          <div className="taggboxNoPost noPostContent hide_post_strip" id="hide_post_strip" >
            <div className="noPostMsgBlock text-center">
                <p>{errorData?.errorMessage} </p>
                <ul className="no_posts_btn w">
                    <li><a onClick={() => onShowDemoPost(0)} className="loadDemoWall btn btn-primary">Hide Demo Posts</a></li>
                </ul>
            </div>
        </div>
    )
}

export default Error